import React, { useContext } from 'react';
import { Field } from 'formik'; //get it like get from loadash, can get value by deep path
import InputMask from 'react-input-mask';
import { FormContext } from './FormContext';

import { appendValidationClassNames } from './utils';
const endsWith = pattern => string => new RegExp(`.*${pattern}$`).test(string);
const ZipInput = props => {
  
  const beforeMaskedValueChange = (newState, oldState, userInput) => {
    var { value } = newState;
    if (!value) value = '';
    var selection = newState.selection;
    var cursorPosition = selection ? selection.start : null;

    // keep minus if entered by user
    if (
      value &&
      typeof value === 'string' &&
      endsWith('-')(value) &&
      userInput !== '-' &&
      !endsWith('-')(props.value)
    ) {
      if (cursorPosition === value.length) {
        cursorPosition--;
        selection = { start: cursorPosition, end: cursorPosition };
      }
      value = value.slice(0, -1);
    }
    
    return {
      value,
      selection
    };
  };

  return (
    <InputMask
      mask="99999-9999"
      maskChar={null}
      {...props}
      autoComplete={props.value?"new-password":''}
      beforeMaskedValueChange={beforeMaskedValueChange}
      onChange={props.onChange}
    />
  );
};

const ZipField = React.forwardRef((props, ref) => {
  const context = useContext(FormContext);
  const { disabled, readOnly } = context ? context : {};
  const extProps = { disabled, readOnly, ...props };

  return (
    <Field
      {...extProps}
      ref={ref}
      render={({ field, form: { touched, errors, setFieldValue } }) => {
        const handleChange = event => {
          let value = event.target.value;
          if (!props.maskedValue) {
            if (value && typeof value === 'string') {
              value = value.replace('-', '');
            }
          }
          setFieldValue(props.name, value);
        };
        const classes = appendValidationClassNames(
          props.className,
          touched,
          errors,
          field.name
        );

        return (
          <ZipInput
            {...field}
            {...extProps}
            className={classes}
            onChange={handleChange}
          />
        );
      }}
    />
  );
});

ZipField.displayName = 'ZipField';

export default ZipField;
